const data = [
  {   
      id: 'aatf',
      logo: 'AATF.png'
  },
  {   
      id: 'anastasia',
      logo: 'Anastasia.png'
  },
  {   
      id: 'anova',
      logo: 'Anova.png'
  },
  {   
      id: 'barebones',
      logo: 'BareBones.png'
  },
  {   
      id: 'bealls',
      logo: 'Bealls.png'
  },
  {   
      id: 'blackbird',
      logo: 'Blackbird.png'
  },
  {   
      id: 'blackovis',
      logo: 'BlackOvis.png'
  },
  {   
      id: 'charming-charlie',
      logo: 'CharmingCharlie.png'
  },
  {   
      id: 'chattanooga-shooting-supplies',
      logo: 'ChattanoogaShooting.png'
  },
  {   
      id: 'chelsea-wine-vault',
      logo: 'ChelseaWineVault.png'
  },
  {   
      id: 'digiwrap',
      logo: 'Digiwrap.png'
  },
  {   
      id: 'dmc',
      logo: 'DMC.png'
  },
  {   
      id: 'drip',
      logo: 'drip.png'
  },
  {   
      id: 'evelyn-arthur',
      logo: 'EvelynArthur.png'
  },
  {   
      id: 'fashion-to-figure',
      logo: 'FashiontoFigure.png'
  },
  {   
      id: 'fortyfiveten',
      logo: 'FortyFiveTen.png'
  },
  {   
      id: 'gohause',
      logo: 'GoHaus.png'
  },
  {   
      id: 'hanky-panky',
      logo: 'HankyPanky.png'
  },
  {   
      id: 'heb',
      logo: 'HEB.png'
  },
  {   
      id: 'home-wet-bar',
      logo: 'HomeWetBar.png'
  },
  {   
      id: 'verizon-hum',
      logo: 'humbyverizon.png'
  },
  {   
      id: 'iboats',
      logo: 'iboats.png'
  },
  {   
      id: 'jellolabs',
      logo: 'JelloLabs.png'
  },
  {   
      id: 'lacrosse-technology',
      logo: 'LaCrosseTechnology.png'
  },
  {   
      id: 'lobstergram',
      logo: 'Lobstergram.png'
  },
  {   
      id: 'mam',
      logo: 'MAM.png'
  },
  {   
      id: 'mood-fabrics',
      logo: 'Mood.png'
  },
  {   
      id: 'no-compromise-gaming',
      logo: 'NoCompromiseGaming.png'
  },
  {   
      id: 'olukai',
      logo: 'Olukai.png'
  },
  {   
      id: 'petsafe',
      logo: 'PetSafe.png'
  },
  {   
      id: 'retrofit-source',
      logo: 'RetrofitSource.png'
  },
  {   
      id: 'rickshaw',
      logo: 'Rickshaw.png'
  },
  {   
      id: 'sally-beauty',
      logo: 'SallyBeauty.png'
  },
  {   
      id: 'shoe-land',
      logo: 'ShoeLand.png'
  },
  {   
      id: 'skinit',
      logo: 'Skinit.png'
  },
  {   
      id: 'sol-republic',
      logo: 'SolRepublic.png'
  },
  {   
      id: 'stackry',
      logo: 'Stackry.png'
  },
  {   
      id: 'translations',
      logo: 'Translations.png'
  },
  {   
      id: 'vip-branding',
      logo: 'VIPBranding.png'
  },
  {   
      id: 'world-emblem',
      logo: 'WorldEmblem.png'
  },
  {   
      id: 'yakima',
      logo: 'Yakima.png'
  },
  {   
      id: 'your-name-pro',
      logo: 'yournamepro.png'
  }
];

export default data;
